import StartEndDateTime from '~/components/forms/StartEndDateTime.jsx';
import {
    formatDateLong,
    formatDateTime,
    formatTime,
    getBrowserTimezone,
    minutesToDuration,
} from '~/lib/DateTime.js';
import { differenceInMinutes, isSameDay, subDays } from 'date-fns';

const EventDateAndTime = ({ event }) => {
    const allDayEnd = subDays(new Date(event.client_end), 1);
    const isAllDaySameDay =
        !!event.event_type?.is_all_day &&
        isSameDay(allDayEnd, new Date(event.client_start));

    return (
        <div className="mb-4">
            <div className="panel-label">Date &amp; Time</div>
            <div className="panel px-6 py-4">
                {!!event.canceled_at && (
                    <div className="text-red-700 mb-2">
                        This was canceled {formatDateTime(event.canceled_at)}
                    </div>
                )}
                {event.event_type?.is_all_day && (
                    <div>
                        {isAllDaySameDay && formatDateLong(event.client_start)}
                        {!isAllDaySameDay &&
                            `${formatDateLong(event.client_start)} - ${formatDateLong(subDays(event.client_end, 1))}`}
                    </div>
                )}
                {!event.event_type?.is_all_day && (
                    <StartEndDateTime
                        start={event.client_start}
                        end={event.client_end}
                    />
                )}
            </div>
            {!!event.client_timezone && (
                <div className="text-gray-500 text-sm ml-4 mt-1">
                    Client time zone is {event.client_timezone}
                </div>
            )}
        </div>
    );
};

export default EventDateAndTime;
